import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { useEffect } from "react";
import { useClientConfigProvider } from "./config/client-config-provider";
import AppRoutes from "./constants/routes";
import { useRouter } from "next/navigation";

export default function withAuthRedirect(Component: any) {
  return function WrappedComponent(props: any) {
    const router = useRouter();
    const { config } = useClientConfigProvider();
    const {
      state: { user, memberships },
    } = useAppContext();

    const { isFetched: isMembershipFetched, data: membershipsData } =
      memberships ?? {};
    const { isFetched: isUserFetched, data: userData } = user ?? {};

    const auth = Boolean(
      UniversalStorageUtils.getItem(
        config?.nativeDataSavingType,
        UniversalStorageConstants.AUTH_TOKEN
      )
    );

    useEffect(() => {
      if (!auth) return;
      if (!isUserFetched || !isMembershipFetched) return; // wait for both

      if (
        config?.userRegistration?.preLoginUserRegistrationForm &&
        !userData?.firstName
      ) {
        // router.push(AppRoutes.register);
      } else if (
        config?.userRegistration?.requiresMembershipLinkBeforeDashboard &&
        !((membershipsData ?? [])?.length > 0)
      ) {
        console.log(
          "USERREGISTRATION",
          ` config?.userRegistration?.requiresMembershipLinkBeforeDashboard &&
        !((membershipsData ?? [])?.length > 0)`
        );
        router.push(
          config?.userRegistration?.afterRegistrationRedirectRoute ??
            AppRoutes.loginLinkMembership
        );
      } else {
        console.log("USERREGISTRATION", `else`);
        router.push(AppRoutes.dashboard);
      }
    }, [
      auth,
      config,
      isUserFetched,
      isMembershipFetched,
      userData?.firstName,
      membershipsData?.length,
      router,
      membershipsData,
    ]);

    return <Component {...props} />;
  };
}
